module.exports = __webpack_public_path__ + "img/CCLF_LOGO_2026.9ccb565b.png";